import { Icon } from 'LocalGluons';
import Theme from 'Theme';
import { ViewStyle } from 'react-native';
import { useChromecastContext } from 'LocalGluons/components/ChromecastContext';

// const useCastSession = Platform.select({
//     default: () => null,
//     android: () => require('react-native-google-cast').useCastSession(),
// });

const container: ViewStyle = {
    zIndex: 9999,
    width: Theme.BU * 2,
    height: Theme.BU * 2
};

interface CastingButtonProps {
    style: ViewStyle,
    onPress: () => void;
    isCasting: boolean
}

export default function CastingButton({ style, onPress, isCasting }: CastingButtonProps) {
    const { castDevice, castSession } = useChromecastContext();

    return (
        <Icon
            key="chromecastButton"
            style={style}
            onPress={onPress}
            name={((castSession && castDevice) ?? isCasting) ? "chromecast_on" : "chromecast_off"}
            testID="chromecast_button"
        />)
}